import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { ComparisonSection } from './components/ComparisonSection';
import { SolutionSection } from './components/SolutionSection';
import { TransformationSection } from './components/TransformationSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <TestimonialsSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <ComparisonSection data-id="element-5" />
      <SolutionSection data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <WhatYouGetSection data-id="element-8" />
      <BonusesSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTA data-id="element-13" />
    </div>;
}